export enum Action {
  CLEAR = 'clear',
  COPY = 'copy',
  DELETE = 'delete',
  RETRIEVE = 'retrieve',
  SAVE = 'save',
  CUSTOM = 'custom',
  NEW = 'new',
  SUBMIT = 'submit',
}
